import { alpha, Collapse, Grid2, Stack, useTheme } from "@mui/material";
import React from "react";
import { EGCheckbox } from "../../../../MainComponents/Checkbox/EGCheckbox";

export const FilterGroup = React.memo(
  ({ name, label, children, checked, onToggle }) => {
    const theme = useTheme();
    return (
      <Grid2 size={{ sx: 12, sm: 6, lg: 4, xl: 3 }} px={0.75}>
        <Stack
          spacing={0.25}
          sx={{
            opacity: checked ? 1 : 0.8,
            mt: 0.3,
            px: 0.5,
            pb: 1,
            border: checked && `${theme.palette.blueGray50.main} 1px solid`,
            borderRadius: 2,
            bgcolor: checked && alpha(theme.palette.blueGray50.main, 0.1),
          }}
        >
          <EGCheckbox
            name={name}
            id={name}
            label={label}
            checked={checked}
            onChange={onToggle}
            color="primary"
          />
          <Collapse in={checked} timeout={250}>
            {children}
          </Collapse>
        </Stack>
      </Grid2>
    );
  }
);
